import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { NbTokenStorage } from '@nebular/auth';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {

  constructor(private router: Router, private tokenStorage: NbTokenStorage) { }

  canActivate(): boolean {
    if (!this.tokenStorage.get().isValid()) {
      this.router.navigate([`${environment.PAGE_AUTH_LOGIN}`]);
      return false;
    }
    return true;
  }

}
